import { AppRouteProps } from "@harea/component";
import React from "react";

const PayrollUserDetailsContainer = React.lazy(() => import('./containers/PayrollUserDetailsContainer'))
export const PayrollUserDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'payroll',
        title: 'Harea.User.Payroll.title',
        element: <PayrollUserDetailsContainer />
    }
]
